/**
 *  Filename ....: event-messages.component.ts
 *  Created by ..: ianday
 *  on Date .....: 2/28/24
 **/
import {Component, OnInit} from '@angular/core';
import {Settings} from "../../../../../services/settings";
import {GeneralSetting} from "../../../../../models/generalsetting";
import {UserService} from "../../../../../services/user.service";

@Component({
    selector: 'app-integration',
    templateUrl: './integration.component.html',
    styleUrls: ['./integration.component.css']
})

export class IntegrationComponent implements OnInit {

    public enabledList:any;
    public selectedValue: string;
    public settingsRecord: any;
    public currentRunState: string;
    public visibleModify: boolean = false;

    constructor(public settingsService: UserService) {
        this.enabledList = [];
        this.enabledList.push({id: 'true', description: 'Enabled'});
        this.enabledList.push({id: 'false', description: 'Disabled'});

    }

    ngOnInit() {
        if(Settings.getInstance().hasPrivilege('GENERAL_SETTINGS_APP_INTEGRATION', "WRITE")) {
           this.visibleModify = true;
        }
        this.settingsRecord = Settings.getInstance().getGeneralSettingByKey('importservice');
        this.selectedValue = this.settingsRecord.value;
        this.currentRunState = this.displayCurrentState(this.selectedValue);
    }

    public updateIntegrationStatus(val: any):void {

        this.settingsRecord.value = val;
        this.settingsService.createUpdateSetting(this.settingsRecord).subscribe(
            (result) => {
                this.currentRunState = this.displayCurrentState(this.selectedValue);
            },
            (error) => {
                Settings.getInstance().handleError(error, 'Updating import service setting');
            });
    }
    public displayCurrentState(runningState: string): string {

        if(runningState === "true") {
            return 'Running ...';
        }

        return 'Suspended ... ';
    }
}


